// # 購物車規則

// # 每種票券單筆最多可買的張數
export const MAX_TICKETS_PER_ITEM = 10;

// # 這張票券最多能放幾張進購物車：不超過單筆上限，也不超過剩餘數量
// 後端沒給剩餘數量時只套用單筆上限
export const getMaxTicketAmount = (remainQuantity) => {
  if (remainQuantity === null || remainQuantity === undefined) {
    return MAX_TICKETS_PER_ITEM;
  }
  const remain = Number(remainQuantity);
  if (Number.isNaN(remain)) return MAX_TICKETS_PER_ITEM;
  return Math.max(0, Math.min(remain, MAX_TICKETS_PER_ITEM));
};
